import React from "react";
import "./banner.css";

const Banner = ({ title, subtitle, image,height }) => {
  return (
    <section
  className="banner text-white py-5"
  style={{ minHeight: height || "400px" }}
>
      <div className="container">
        <div className="row align-items-center">

          {/* Text */}
          <div className={`text-center pt-5 mt-5 mb-4 ${
            image ? "col-lg-5 text-lg-start" : "col-12"
          }`}>
            <h1 className="display-5 fw-bold">{title}</h1>

            <p className="text-white-50">{subtitle}</p>

            
          </div>

          {/* ✅ Show image ONLY if exists */}
          {image && (
            <div className="col-lg-7 text-center">
              <img
                src={image}
                alt="banner"
                className="img-fluid banner-img"
              />
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default Banner;